import bee from "./Bee"
import promotion_tiles from "./promotion_tiles"
export default {
    name: "Home",
    /*
        var query = {
            old_password: "",
            new_password: "",
            phone_number: ""
        }
    */
    /* eslint-disable no-unused-vars */
    get_promotion_tiles(query, success, fail) {
        var data = promotion_tiles.items;
        success(data);
    },
    load_home_page(query, success, fail){
        var qo = {
            _julz:{
                _gets:{
                    home_page_slides:{
                        sliders: {
                            _ob: ["position"],
                            _w: [
                                ["page","e","home"]
                            ]
                        }
                    },
                    holidays:{
                        hollidays: {
                            _ob: ["starts_on_timestamp"]
                        },
                    },
                    latest_promotions: {
                        promotions: {
                            business: {},
                            _pg: 3,
                            _w: [
                                [
                                    [
                                        ["has_been_ended","e",0],
                                        "AND",
                                        ["starts_on_timestamp","lte", query.time_now ]
                                    ],
                                    "AND",
                                    ["ends_on_timestamp","gte", query.time_now ]
                                ]
                            ]
                        }
                    },
                    latest_businesses:{
                        businesses: {
                            _desc: ["joined_on_timestamp"],
                            _pg: 4
                        },
                    }, //_indexconfig_belongings
                    top_categories: {
                        categories: {
                            _pg: 7,
                            _ob: ["top_category_level"],
                            _w: [
                                ["is_top_category", "e", 1]
                            ]
                        },
                    },
                    indexed_sub_categories: {
                        sub_categories: {
                            _a: " category_id _count_category_id ",
                            _gb: ["category_id"]
                        },
                        _indexconfig_sub_categories: {
                            path: "sub_categories.category_id",
                            key: "category_id"
                        },
                    },
                    index_category_belongings:{
                        belongings: {
                            _a: " category_id _countd_business_id ",
                            _gb: ["category_id"]
                        },
                        _indexconfig_belongings: {
                            path: "belongings.category_id",
                            key: "category_id"
                        },
                    },
                    most_viewed_businesses:{
                        businesses: {
                            _desc: ["views_count"],
                            _pg: 8
                        }
                    }
                }
            }
        };
        bee.get(qo)
        .then(res => {
            if (success) {
                success(res.julz.gets);
            }
        })
        .catch(errors => {
            if (fail) {
                fail(errors);
            }
        });
    }
}